<template>
  <div class="property-item rounded overflow-hidden">
    <div class="position-relative overflow-hidden">
      <router-link :to="`/property-details`" @click="storePropertyId">
        <img class="img-fluid" :src="property.image" :alt="property.title" />
      </router-link>
      <div class="bg-primary rounded text-white position-absolute start-0 top-0 m-4 py-1 px-3">
        {{ property.status }}
      </div>
      <div class="bg-white rounded-top text-primary position-absolute start-0 bottom-0 mx-4 pt-1 px-3">
        {{ property.type }}
      </div>
    </div>
    <div class="p-4 pb-0">
      <h5 class="text-primary mb-3">{{ property.price }}</h5>
      <router-link class="d-block h5 mb-2" :to="`/property-details`" @click="storePropertyId">{{ property.title }}</router-link>
      <p><i class="fa fa-map-marker-alt text-primary me-2"></i>{{ property.location }}</p>
    </div>
    <div class="d-flex border-top">
      <small class="flex-fill text-center border-end py-2">
        <i class="fa fa-ruler-combined text-primary me-2"></i>{{ property.sqft }} Sqft
      </small>
      <small class="flex-fill text-center border-end py-2">
        <i class="fa fa-bed text-primary me-2"></i>{{ property.beds }} Bed
      </small>
      <small class="flex-fill text-center py-2">
        <i class="fa fa-bath text-primary me-2"></i>{{ property.baths }} Bath
      </small>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue'

interface Property {
  id: number
  image: string
  status: string
  type: string
  price: string
  title: string
  location: string
  sqft: number
  beds: number
  baths: number
}

export default defineComponent({
  props: {
    property: {
      type: Object as PropType<Property>,
      required: true
    },
    delay: {
      type: Number,
      default: 0.1
    }
  },
  methods: {
    storePropertyId () {
      localStorage.setItem('propertyId', this.property.id.toString())
    }
  }
})
</script>

<style scoped>
.property-item {
  transition: transform 0.3s
}
.property-item:hover {
  transform: translateY(-5px)
}
</style>
